import { render, staticRenderFns } from "./DashboardWelcomeBanner.vue?vue&type=template&id=777c6c2a&scoped=true&"
import script from "./DashboardWelcomeBanner.vue?vue&type=script&lang=js&"
export * from "./DashboardWelcomeBanner.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWelcomeBanner.vue?vue&type=style&index=0&id=777c6c2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c6c2a",
  null
  
)

export default component.exports